/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Pencil, Trash2, ChevronDown, ChevronUp, SquarePen } from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Table,
  Collapse,
  Modal
} from 'react-bootstrap'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { BadgeStatusPrListInbounds } from '../../../components/atoms/StatusLabel'
import CustomButton from '../../../components/Button/CustomButton'
import Breadcrumb from '../../../components/Label/Breadcrumb'
import ModalAddUpdateItem from '../../../components/modal/Sj/ModalAddUpdateItem'
import ModalSelectFormat from '../../../components/modal/Sj/ModalSelectFormat'
import ModalSolveContinueTicket from '../../../components/modal/Sj/ModalSolveContinueTicket'
import ModalUpdateRequest from '../../../components/modal/Sj/ModalUpdateRequest'
import ModalStockAdjustment from '../../../components/modal/stockAdjustment/ModalStockAdjustment'
import AlertIcon from '../../../components/atoms/Icons/AlertIcon'
import CustomCloseButton from '../../../components/Button/CustomCloseButton'
import api from '../../../config/AxiosInstance'
import {
  convertDateWithoutTime,
  convertDateWithTime
} from '../../../helpers/constants'
import * as Common from '../../../utils/Common'
import { firstLetterUpperCase } from '../../../utils/TextFormatter'
import Loading from '../../../components/atoms/Loading'
import toast, { Toaster } from 'react-hot-toast'
const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '18px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}
const DetailTransfer = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [detail, setDetail] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [showModalAddUpdateItem, setShowModalAddUpdateItem] = useState(false)
  const [showModalDeleteRequest, setShowModalDeleteRequest] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState(null)
  const [showModalUpdateRequest, setShowModalUpdateRequest] = useState(false)
  const [loadingDeleteRequest, setLoadingDeleteRequest] = useState(false)
  const [updateRequest, setUpdateRequest] = useState({
    request_id: '',
    sjDraftId: '',
    sjCode: '',
    item_id: '',
    item_name: '',
    item_alias: '',
    batch_id: '',
    slot_id: '',
    batch: '',
    slot: '',
    qty: 0,
    total_pack: 0,
    warehouse: null,
    item_code: ''
  })
  const [showModalSolveContinueTicket, setShowModalSolveContinueTicket] =
    useState(false)
  const [submitSolveContinueTicket, setSubmitSolveContinueTicket] =
    useState(false)
  const [requestCommand, setRequestCommand] = useState([])
  const [pickupCommand, setPickupCommand] = useState([])
  const [loadingDownloadPrint, setDownloadPrint] = useState({
    coaDownload: false,
    coaPrint: false,
    trDownload: false,
    trPrint: false
  })
  const [showModalSelectFormat, setShowModalSelectFormat] = useState(false)
  const [selectFormatDownload, setSelectFormatDownload] = useState({
    type: 'tr',
    format: null,
    action: null,
    id: null
  })
  const [loadingFormat, setLoadingFormat] = useState(false)
  const [progressDetailCollapse, setProgressDetailCollapse] = useState(true)
  const [iconProgressDetailCollapse, setIconProgressDetailCollapse] =
    useState('down')
  const [editData, setEditData] = useState({
    type: 'create',
    command_id: null,
    item_code: null,
    item_alias: null,
    item_batch_id: null,
    total_pack: null,
    exp_date: null,
    qty: 0
  })

  useEffect(() => {
    fetchDetailTransfer()
  }, [id])

  const fetchDetailTransfer = async () => {
    try {
      setIsLoading(true)
      const res = await api.get(`/outbound/transfer/detail/${id}`)
      const { data } = res
      if (data.success) {
        setDetail(data.data)
        setRequestCommand(data.data.requests)
        setPickupCommand(data.data.pickup_command)
        setUpdateRequest((prevUpdateRequest) => ({
          ...prevUpdateRequest,
          warehouse: data.data?.src || '',
          sjDraftId: data.data?.id || '',
          sjCode: data.data?.draft_code || ''
        }))
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoading(false)
    }
  }

  const handleUpdateRequest = (
    itemCode = null,
    itemName = null,
    itemAlias = null,
    requestId = null
  ) => {
    const show = !showModalUpdateRequest
    setShowModalUpdateRequest(show)
    if (show && itemCode) {
      setUpdateRequest((prevUpdateRequest) => ({
        ...prevUpdateRequest,
        item_code: itemCode,
        item_name: itemName,
        item_alias: itemAlias,
        request_id: requestId
      }))
    } else {
      setUpdateRequest((prevUpdateRequest) => ({
        ...prevUpdateRequest,
        item_id: '',
        item_name: '',
        item_alias: '',
        request_id: '',
        batch_id: '',
        slot_id: '',
        batch: '',
        slot: '',
        qty: 0,
        total_pack: 0,
        item_code: ''
      }))
    }
  }

  const handleDeleteRequest = async () => {
    try {
      setLoadingDeleteRequest(true)
      const res = await api.delete(
        `/outbound/sjdraft/${updateRequest.sjDraftId}/so/${selectedRequest}`
      )
      const { data } = res
      if (data.success) {
        Common.showPopUpSuccessMessage('Successfully deleted request')
        fetchDetailTransfer()
        setShowModalDeleteRequest(false)
        setSelectedRequest(null)
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingDeleteRequest(false)
    }
  }

  const handleSubmitSolveContinueTicket = async (type = 'direct') => {
    try {
      setSubmitSolveContinueTicket(true)
      const solvedPickupCommands = pickupCommand
        .filter((item) => !item.is_new_command)
        .map((item) => ({
          command_id: item.command_id
        }))

      const newPickupCommands = pickupCommand
        .filter((item) => item.is_new_command)
        .map((item) => ({
          command_id: null,
          item_code: item.item_code,
          batch: item.batch,
          location: item.location,
          total_pack: item.total_pack,
          item_alias: item.item_alias
        }))

      const newSlotLocations = pickupCommand
        .filter((item) => item.is_new_command)
        .map((item) => ({
          need_qty: Number(item.total_pack) || 0,
          available_qty: Number(item.total_pack) || 0,
          item_batch: item.batch,
          items: [
            {
              item_name: item.item_name,
              item_alias: item.item_alias || null,
              item_code: item.item_code,
              batch: item.batch,
              qty: Number(item.total_pack) || 0,
              uom: item.uom || 'Kg',
              uom_pack: item.uom_pack,
              location: item.location
            }
          ]
        }))

      const res = await api.post(
        `outbound/sjdraft/${detail?.id}/solve-problem`,
        {
          pickup_command: [...solvedPickupCommands, ...newPickupCommands],
          slot_locations: [
            ...(detail?.slot_locations || []),
            ...newSlotLocations
          ]
        }
      )
      if (res.data.success) {
        fetchDetailTransfer()
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setSubmitSolveContinueTicket(false)
      if (type === 'modal') {
        setShowModalSolveContinueTicket(false)
      }
    }
  }

  const handleDeleteAddItemPickupCommand = (commandId) => {
    setPickupCommand((prev) =>
      prev.filter((item) => item.command_id !== commandId)
    )
  }

  const handleSendToErp = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Send to ERP?',
        text: 'This action can’t be repeated!',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send!',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          sendToErp()
        } else {
          return false
        }
      })
  }

  const sendToErp = async () => {
    try {
      const res = await api.post(`outbound/transfer/${detail?.id}/send-erp`)
      const { data } = res
      if (data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Send to erp success'
        })
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      fetchDetailTransfer()
    }
  }

  const handleDownloadPrint = async (type, typeAction, id) => {
    try {
      if (type !== 'tr') {
        setDownloadPrint((downloadPrint) => {
          return {
            ...downloadPrint,
            [type + firstLetterUpperCase(typeAction)]: true
          }
        })
      } else {
        setLoadingFormat(true)
      }
      if (type === 'tr') {
        const res = await api.get(
          `/outbound/transfer/file-tr/${id}?print=${encodeURIComponent(
            selectFormatDownload?.format
          )}&action=${typeAction}`,
          {
            responseType: typeAction === 'print' ? 'text' : 'arraybuffer'
          }
        )
        const { status, data, headers } = res
        if (status === 200) {
          const contentType = headers?.['content-type'] || ''
          if (typeAction === 'print') {
            if (contentType.includes('text/html') || typeof data === 'string') {
              Common.printDocument(data, true)
            } else {
              const blob = new Blob([data], { type: 'application/pdf' })
              Common.printDocument(blob)
            }
          } else if (typeAction === 'download') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `file-tr-${id}.pdf`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }
        }
      }
      if (type === 'coa') {
        const res = await api.get(`/outbound/sjdraft/file-coa/${id}`, {
          responseType: 'arraybuffer'
        })
        const { status, data } = res
        if (status === 200) {
          const blob = new Blob([data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)
          if (typeAction === 'download') {
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `file-coa-${id}.pdf`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }
          if (typeAction === 'print') {
            Common.printPdf(blob)
          }
        }
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      if (type === 'tr') {
        setLoadingFormat(false)
        setShowModalSelectFormat(false)
        setSelectFormatDownload((prevSelectFormatDownload) => ({
          ...prevSelectFormatDownload,
          id: null,
          format: null
        }))
      } else {
        setDownloadPrint((downloadPrint) => {
          return {
            ...downloadPrint,
            [type + firstLetterUpperCase(typeAction)]: false
          }
        })
      }
    }
  }
  const createWorkOrder = async (item) => {
    try {
      if (!detail?.draft_code) {
        return toast.error('Draft code not found', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      }
      const body = {
        sj: detail?.draft_code,
        command: item
      }
      const res = await api.post('/outbound/work-order', body)
      const { data } = res
      if (data.success) {
        toast.success('Create work order success', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        navigate('/workorder/plan', { replace: true })
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    }
  }
  const handleCreateWorkOrder = (item) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Create Work Order?',
        text: 'Create work order for this item alias?',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Create',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          createWorkOrder(item)
        } else {
          return false
        }
      })
  }

  const renderInfoItem = (label, value, col = 3) => (
    <Col md={col} className="mb-3">
      <small style={labelStyle}>{label}</small>
      <h5
        className="mt-1"
        style={{ fontSize: '1.05rem', wordBreak: 'break-word' }}
      >
        {value || '-'}
      </h5>
    </Col>
  )

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Toaster />
      <Container fluid className="px-4 mb-5">
        <Row className="mb-4">
          <Col
            md={12}
            className="d-flex justify-content-between align-items-start"
          >
            <div className="d-flex flex-column justify-content-start">
              {!searchParams.get('outboundId') ? (
                <Breadcrumb
                  label={detail?.draft_code}
                  link="/outbound/transfer"
                  back="TR"
                  type="BadgeStatusPrListInbounds"
                  status={detail?.status}
                />
              ) : (
                <>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-1">
                      <li className="breadcrumb-item sj-item">
                        <Link
                          to={'/outbound/transfer'}
                          className="text-decoration-none"
                        >
                          <span className="text-black fw-bold text-uppercase">
                            Outbound
                          </span>
                        </Link>
                      </li>
                      <li className="breadcrumb-item sj-item">
                        <Link
                          to={`/outbound/plan/detail/${searchParams.get(
                            'outboundId'
                          )}`}
                          className="text-decoration-none"
                        >
                          <span className="text-black fw-bold text-uppercase">
                            {searchParams.get('outboundCode')}
                          </span>
                        </Link>
                      </li>
                      <li
                        className="breadcrumb-item sj-item active"
                        aria-current="page"
                      >
                        {detail?.draft_code}
                      </li>
                    </ol>
                  </nav>
                  <h4
                    style={headerTitleStyle}
                    className="d-flex align-items-center gap-2"
                  >
                    {detail?.draft_code}{' '}
                    <BadgeStatusPrListInbounds text={detail?.status} />
                  </h4>
                </>
              )}
            </div>

            {detail?.status !== 'unassigned' && (
              <div className="d-flex flex-row gap-2">
                {detail?.status === 'problem' && (
                  <CustomButton
                    variant={'transparent'}
                    style={{ backgroundColor: '#F89D1D', whiteSpace: 'nowrap' }}
                    text={'Solve problem and continue ticket'}
                    onClick={() => setShowModalSolveContinueTicket(true)}
                  />
                )}
                {['done', 'ongoing'].includes(detail?.status) && (
                  <>
                    <CustomButton
                      variant={'transparent'}
                      style={{
                        backgroundColor: '#F89D1D',
                        display: `${
                          detail?.status === 'ongoing' ? 'none' : 'block'
                        }`,
                        whiteSpace: 'nowrap'
                      }}
                      text={
                        loadingDownloadPrint.trDownload
                          ? 'Downloading...'
                          : 'Download TR'
                      }
                      onClick={() => {
                        setShowModalSelectFormat(true)
                        setSelectFormatDownload((prevSelectFormatDownload) => ({
                          ...prevSelectFormatDownload,
                          id: detail?.id,
                          action: 'download'
                        }))
                      }}
                    />
                    <CustomButton
                      variant={'transparent'}
                      style={{
                        backgroundColor: '#203568',
                        display: `${
                          detail?.status === 'ongoing' ? 'none' : 'block'
                        }`,
                        whiteSpace: 'nowrap'
                      }}
                      text={
                        loadingDownloadPrint.trPrint
                          ? 'Printing...'
                          : 'Print TR'
                      }
                      onClick={() => {
                        setShowModalSelectFormat(true)
                        setSelectFormatDownload((prevSelectFormatDownload) => ({
                          ...prevSelectFormatDownload,
                          id: detail?.id,
                          action: 'print'
                        }))
                      }}
                    />
                    <CustomButton
                      variant={'transparent'}
                      style={{
                        backgroundColor: '#F89D1D',
                        whiteSpace: 'nowrap'
                      }}
                      text={
                        loadingDownloadPrint.coaDownload
                          ? 'Downloading...'
                          : 'Download C.O.A'
                      }
                      onClick={() =>
                        handleDownloadPrint('coa', 'download', detail?.id)
                      }
                    />
                    <CustomButton
                      variant={'transparent'}
                      style={{
                        backgroundColor: '#203568',
                        whiteSpace: 'nowrap'
                      }}
                      text={
                        loadingDownloadPrint.coaPrint
                          ? 'Printing...'
                          : 'Print C.O.A'
                      }
                      onClick={() =>
                        handleDownloadPrint('coa', 'print', detail?.id)
                      }
                    />
                  </>
                )}
              </div>
            )}
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem('Series', detail?.series_number, 3)}
            {renderInfoItem('Source Warehouse', detail?.src_warehouse, 3)}
            {renderInfoItem('Target Warehouse', detail?.target_warehouse, 3)}
            {renderInfoItem('#ERP Doc No', detail?.erp?.erp_status ?? '-', 3)}
            {renderInfoItem(
              'Delivery Date',
              detail?.delivery_date
                ? convertDateWithoutTime(detail?.delivery_date)
                : '-',
              3
            )}
            {renderInfoItem('#MR', detail?.mr, 3)}
            {detail?.status !== 'unassigned' && (
              <>
                {renderInfoItem('PNP', detail?.checker?.pnp ?? '-', 3)}
                {renderInfoItem('RNR', detail?.checker?.rnr ?? '-', 3)}
              </>
            )}
          </Row>
        </Card>

        <Card style={cardFilterStyle}>
          <Row>
            <Col>
              <h5 className="fw-bold text-uppercase mb-3">REQUEST</h5>
              <Table
                hover
                responsive
                className="shadow-sm bg-white"
                style={{
                  fontSize: '13px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  marginBottom: 0
                }}
              >
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      #
                    </th>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      Item
                    </th>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      Item Alias
                    </th>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      Item Code
                    </th>
                    <th className="p-2 text-end" style={tableHeaderStyle}>
                      Qty
                    </th>
                    <th
                      className="p-2 text-end align-middle"
                      style={tableHeaderStyle}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!detail?.requests.length && (
                    <tr>
                      <td className="p-2" colSpan={5}>
                        No Data
                      </td>
                    </tr>
                  )}
                  {detail?.requests.length &&
                    detail?.requests.map((request, index) => (
                      <tr key={request.item_code}>
                        <td className="p-2">{index + 1}</td>
                        <td className="p-2">{request.item_name}</td>
                        <td className="p-2">{request.item_alias ?? '-'}</td>
                        <td className="p-2">{request.item_code}</td>
                        <td className="p-2 text-end">{request.qty}</td>
                        <td className="p-2 text-end align-middle">
                          <div className="d-flex gap-2 justify-content-end">
                            <Button
                              size="sm"
                              variant={
                                detail?.status === 'done'
                                  ? 'secondary'
                                  : 'danger'
                              }
                              className={
                                detail?.status === 'done' ? 'opacity-25' : ''
                              }
                              disabled={detail?.status === 'done'}
                              onClick={() => {
                                setShowModalDeleteRequest(true)
                                setSelectedRequest(
                                  request.request_id || request.item_code
                                )
                              }}
                            >
                              <Trash2 size={14} />
                            </Button>
                            <Button
                              size="sm"
                              variant="secondary"
                              className={
                                detail?.status === 'done' ? 'opacity-25' : ''
                              }
                              disabled={detail?.status === 'done'}
                              onClick={() =>
                                handleUpdateRequest(
                                  request.item_code || null,
                                  request.item_name || null,
                                  request.item_alias || null,
                                  request.request_id || null
                                )
                              }
                            >
                              <SquarePen size={14} />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card>

        <Card style={cardFilterStyle}>
          <Row className="mb-3">
            <Col
              md={12}
              className="d-flex justify-content-between align-items-center"
            >
              <h5 className="fw-bold text-uppercase mb-0">PICK UP COMMAND</h5>
              {detail?.status === 'problem' && (
                <CustomButton
                  variant={'transparent'}
                  style={{ backgroundColor: '#F89D1D' }}
                  text={'Add'}
                  onClick={() => {
                    setEditData({
                      type: 'create',
                      command_id: null,
                      item_code: null,
                      item_alias: null,
                      item_batch_id: null,
                      total_pack: null,
                      exp_date: null,
                      qty: 0
                    })
                    setShowModalAddUpdateItem(true)
                  }}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Table
                hover
                responsive
                className="shadow-sm bg-white"
                style={{
                  fontSize: '13px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  marginBottom: 0
                }}
              >
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      #
                    </th>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      Item
                    </th>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      Item Alias
                    </th>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      Item Code
                    </th>
                    <th
                      className="p-2 align-middle text-end"
                      style={tableHeaderStyle}
                    >
                      Batch
                    </th>
                    <th
                      className="p-2 align-middle text-end"
                      style={tableHeaderStyle}
                    >
                      Expired
                    </th>
                    <th
                      className="p-2 align-middle text-end"
                      style={tableHeaderStyle}
                    >
                      Total Qty
                    </th>
                    <th
                      className="p-2 align-middle text-end"
                      style={tableHeaderStyle}
                    >
                      Total Pack
                    </th>
                    <th
                      className="p-2 align-middle text-center"
                      style={tableHeaderStyle}
                    >
                      Location
                    </th>
                    {!detail?.erp?.erp_status && (
                      <th className="p-2 align-middle" style={tableHeaderStyle}>
                        Action
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {!detail?.pickup_command.length && (
                    <tr>
                      <td className="p-2" colSpan={9}>
                        No Data
                      </td>
                    </tr>
                  )}
                  {detail?.pickup_command.length &&
                    detail?.pickup_command.map((pickup_command, index) => (
                      <tr key={pickup_command.item_code}>
                        <td className="p-2">{index + 1}</td>
                        <td className="p-2">{pickup_command.item_name}</td>
                        <td className="p-2">
                          {pickup_command.item_alias ?? '-'}
                        </td>
                        <td className="p-2">{pickup_command.item_code}</td>
                        <td className="p-2 text-end">{pickup_command.batch}</td>
                        <td className="p-2 text-end">
                          {pickup_command.exp_date
                            ? convertDateWithoutTime(pickup_command.exp_date)
                            : '-'}
                        </td>
                        <td className="p-2 text-end">
                          {pickup_command.qty} {pickup_command.uom}
                        </td>
                        <td className="p-2 text-end">
                          {!pickup_command?.total_pack
                            ? '-'
                            : parseInt(pickup_command?.total_pack)}
                          {pickup_command.report_pack > 0 && (
                            <span className="text-danger ms-2">
                              ({`-${pickup_command?.report_pack}`})
                            </span>
                          )}
                        </td>
                        <td
                          className="p-2 text-primary cursor-pointer text-truncate"
                          role="button"
                          title={pickup_command?.location}
                          style={{
                            maxWidth: '20px'
                          }}
                        >
                          <Link
                            to={'/outbound/transfer/location'}
                            state={{
                              slotLocations: detail?.slot_locations,
                              batch: pickup_command?.batch,
                              trCode: detail?.draft_code,
                              trId: detail?.id
                            }}
                            className="text-decoration-none"
                          >
                            {!pickup_command.location
                              ? '-'
                              : pickup_command.location}
                          </Link>
                        </td>
                        {!detail?.erp?.erp_status && (
                          <td className="p-2">
                            <div className="d-flex flex-row gap-2 justify-content-end">
                              <Button
                                variant="transparent"
                                className={`btn ${
                                  pickup_command?.has_wo === true
                                    ? 'btn-secondary'
                                    : 'btn-primary-blue'
                                } ml-2 ${
                                  !pickup_command?.item_alias ? 'd-none' : ''
                                }`}
                                disabled={pickup_command?.has_wo === true}
                                size="sm"
                                onClick={() =>
                                  handleCreateWorkOrder(pickup_command)
                                }
                              >
                                + WO
                              </Button>
                              <button
                                className={`btn ${
                                  !pickup_command?.is_new_command
                                    ? 'btn-secondary'
                                    : 'btn-danger'
                                }`}
                                onClick={() =>
                                  handleDeleteAddItemPickupCommand(
                                    pickup_command?.command_id
                                  )
                                }
                                disabled={!pickup_command?.is_new_command}
                              >
                                <Trash2 size={16} />
                              </button>
                              <button
                                className="btn btn-secondary"
                                disabled={!pickup_command?.is_new_command}
                                onClick={() => {
                                  setShowModalAddUpdateItem(true)
                                  setEditData({
                                    type: 'update',
                                    command_id: pickup_command?.command_id,
                                    item_code: pickup_command?.item_code,
                                    item_alias:
                                      pickup_command?.item_alias ?? '-',
                                    item_batch_id:
                                      pickup_command?.item_batch_id,
                                    total_pack: pickup_command?.total_pack,
                                    exp_date: convertDateWithoutTime(
                                      pickup_command?.expired
                                    ),
                                    qty: pickup_command?.qty
                                  })
                                }}
                              >
                                <Pencil size={16} />
                              </button>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card>

        {detail?.is_finish_loading && !detail?.erp?.erp_status && (
          <Row className="mb-3">
            <Col md={12}>
              <Card className="border-danger">
                <Card.Body>
                  <Row>
                    <Col md={6} hidden={!detail?.erp?.err_notes}>
                      <p>
                        {detail?.erp?.description}, status:
                        <span
                          style={{
                            color:
                              detail?.erp?.erp_status === true
                                ? 'green'
                                : '#C12727'
                          }}
                          className="ms-2 fw-bold text-uppercase"
                        >
                          {detail?.erp?.erp_status === true
                            ? 'Success'
                            : 'Failed'}
                        </span>
                      </p>
                      <div className="d-flex flex-row gap-2">
                        <span>Failed Reason: </span>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: detail?.erp?.err_notes
                          }}
                        ></div>
                      </div>
                    </Col>
                    <Col
                      md={!detail?.erp?.err_notes ? 12 : 6}
                      className="d-flex flex-row justify-content-end align-items-center"
                    >
                      <CustomButton
                        variant={'transparent'}
                        style={{ backgroundColor: '#F89D1D' }}
                        text={'Send to ERP'}
                        onClick={() => handleSendToErp()}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        <Card style={cardFilterStyle} className="mt-4">
          <div className="d-flex justify-content-between align-items-center cursor-pointer mb-3">
            <h5 className="fw-bold text-uppercase mb-0">Progress Detail</h5>
            <Button
              variant="transparent"
              className="p-0 text-secondary"
              onClick={() => {
                const status = !progressDetailCollapse
                setProgressDetailCollapse(status)
                setIconProgressDetailCollapse(status ? 'up' : 'down')
              }}
            >
              {iconProgressDetailCollapse === 'up' ? (
                <ChevronUp size={20} />
              ) : (
                <ChevronDown size={20} />
              )}
            </Button>
          </div>
          <Collapse in={progressDetailCollapse}>
            <div id="progress-collapse" className="mt-4 ms-3 position-relative">
              <div
                className="position-absolute"
                style={{
                  top: '0',
                  bottom: '0',
                  left: '6px',
                  borderLeft: '2px solid #e9ecef',
                  zIndex: 0
                }}
              />
              {detail?.progress_detail?.length > 0 ? (
                detail?.progress_detail?.map((progress, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-start mb-3 position-relative"
                    style={{ zIndex: 1 }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center bg-white"
                      style={{
                        width: '14px',
                        height: '14px',
                        borderRadius: '50%',
                        border: '2px solid var(--primary-orange)',
                        marginTop: '4px',
                        marginRight: '1rem',
                        flexShrink: 0
                      }}
                    >
                      <div
                        style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          backgroundColor: 'var(--primary-orange)'
                        }}
                      />
                    </div>
                    <div className="w-100">
                      <div
                        className="text-secondary small mb-1"
                        style={{ fontSize: '0.75rem', marginTop: '2px' }}
                      >
                        {progress?.datetime || '-'}
                      </div>
                      <div
                        className="fw-bold text-dark"
                        style={{ fontSize: '0.9rem' }}
                      >
                        {progress?.description}
                        {progress?.detail?.length > 0 && (
                          <ul
                            className="list-unstyled mt-2 mb-0"
                            style={{ marginLeft: '1rem' }}
                          >
                            {progress?.detail?.map((detailItem, idx) => (
                              <li
                                key={idx}
                                style={{
                                  color: `${detailItem.color || 'black'}`,
                                  fontSize: '0.85rem'
                                }}
                                className="mb-1"
                              >
                                {detailItem?.description}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="p-2 text-muted fst-italic">Data Empty!</div>
              )}
            </div>
          </Collapse>
        </Card>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem('CREATED BY', detail?.created_by, 3)}
            {renderInfoItem(
              'CREATED AT',
              detail?.createdAt ? convertDateWithTime(detail?.createdAt) : '-',
              3
            )}
            {renderInfoItem('LAST UPDATE BY', detail?.updated_by, 3)}
            {renderInfoItem(
              'LAST UPDATE AT',
              detail?.updatedAt ? convertDateWithTime(detail?.updatedAt) : '-',
              3
            )}
          </Row>
        </Card>

        <ModalSolveContinueTicket
          show={showModalSolveContinueTicket}
          onHide={() => setShowModalSolveContinueTicket(false)}
          handleSubmitSolveContinueTicket={() =>
            handleSubmitSolveContinueTicket('modal')
          }
          submitSolveContinueTicket={submitSolveContinueTicket}
        />

        <ModalSelectFormat
          show={showModalSelectFormat}
          handleClose={() => {
            setShowModalSelectFormat(false)
            setSelectFormatDownload((prevSelectFormatDownload) => ({
              ...prevSelectFormatDownload,
              id: null,
              format: null
            }))
          }}
          setSelectFormatDownload={setSelectFormatDownload}
          selectFormatDownload={selectFormatDownload}
          handleDownloadPrint={handleDownloadPrint}
          loadingFormat={loadingFormat}
        />
        <ModalUpdateRequest
          show={showModalUpdateRequest}
          onHide={() => handleUpdateRequest()}
          data={updateRequest}
          refreshData={() => fetchDetailTransfer()}
          dataRequest={detail?.requests || []}
        />

        <ModalStockAdjustment
          show={showModalDeleteRequest}
          onHide={() => {
            setShowModalDeleteRequest(false)
            setSelectedRequest(null)
          }}
          size="md"
          title=""
        >
          <Modal.Body>
            <div className="d-flex justify-content-center py-2 my-2">
              <div className="d-flex flex-column justify-content-center">
                <div className="d-flex justify-content-center">
                  <AlertIcon width={131} height={130} />
                </div>
                <div className="text-center my-3">
                  <h6 style={{ fontSize: '15px' }}>
                    Are you sure deleted request, data permanently delete?
                  </h6>
                </div>
              </div>
            </div>
            <Modal.Footer className="mt-3">
              <CustomCloseButton
                onClick={() => {
                  setShowModalDeleteRequest(false)
                  setSelectedRequest(null)
                }}
                text="Cancel"
              />
              <CustomButton
                onClick={() => handleDeleteRequest()}
                variant={loadingDeleteRequest ? 'secondary' : 'danger'}
                disabled={loadingDeleteRequest}
                text={!loadingDeleteRequest ? 'Delete' : 'Deleting...'}
                classNameValue={`text-white ${
                  loadingDeleteRequest ? 'opacity-25' : ''
                }`}
              />
            </Modal.Footer>
          </Modal.Body>
        </ModalStockAdjustment>

        <ModalAddUpdateItem
          show={showModalAddUpdateItem}
          onHide={() => setShowModalAddUpdateItem(false)}
          data={editData}
          reportPickupCommand={pickupCommand?.filter(
            (item) => item.report_pack > 0
          )}
          pickupCommand={pickupCommand}
          command={detail?.requests}
          sjDraftId={detail?.id}
          options={pickupCommand
            ?.filter((item) => item.report_pack > 0)
            .reduce((acc, cur) => {
              acc.push({
                id: cur?.item_code,
                label: cur?.item_name
              })
              return acc
            }, [])}
          onSave={(newItem) => {
            if (editData.type === 'create') {
              setPickupCommand((prev) => [...prev, newItem])
            } else {
              setPickupCommand((prev) =>
                prev.map((item) =>
                  item.command_id === editData.command_id
                    ? { ...item, ...newItem }
                    : item
                )
              )
            }
          }}
        />
      </Container>
    </>
  )
}

export default DetailTransfer
